<div class="component-main-container">
  <!-- sessão header -->
  <div class="header">
    <app-page-header parentTitle="{{'permissions-group.parentTitle' | translate}}"
      pageTitle="{{'permissions-group.pageTitle' | translate}}"></app-page-header>
  </div>

  <!-- div responsável por fazer com que a tela se comporte como uma linha -->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <!-- div responsavel por armazenas as box da página -->
      <div class="component-forms-box">

        <!-- box responsável pela criação de grupos de permissões -->
        <div class="form-fields-box" [ngClass]="!registerPermissionsGroupBox ? 'closed' : ''"
          [formGroup]="permissionsGroupRegisterForm">
          <h2 (click)="registerPermissionsGroupOpen()">
            {{'permissions-group.register-form' | translate}}
          </h2>
          <hr [ngClass]="!registerPermissionsGroupBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label> {{'permissions-group.register-form-name' | translate}} </mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label> {{'permissions-group.register-form-user-permission' | translate}} </mat-label>
              <mat-select multiple>
                <mat-option #availablePermissionsCheck
                  (click)="selectAllAvailablePermissions(availablePermissionsCheck)">
                  {{'permissions-group.select-all-permissions' | translate}}
                </mat-option>
                @for (availablePermissions of availablePermissionsList; track availablePermissions) {
                <mat-checkbox color="primary" (change)="checkAvailablePermissions(availablePermissions.id)"
                  [checked]="availablePermissions.checked" [id]="availablePermissions.id">
                  {{availablePermissions.name}}
                </mat-checkbox>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (!createPermissionsGroupLoading) {
          <button title="Salvar" class="btn btn-success" (click)="createPermissionsGroup()">
            {{'permissions-group.register-form-button' | translate}}
          </button>
          }
          @if (createPermissionsGroupLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <!-- box responsável pelo filtro de grupos de permissões -->
        <div class="form-fields-box" [ngClass]="!filterPermissionsGroupBox ? 'closed' : ''"
          [formGroup]="permissionsGroupFilterForm">
          <h2 (click)="filterPermissionsGroupOpen()">
            {{'permissions-group.filter-form' | translate}}
          </h2>
          <hr [ngClass]="!filterPermissionsGroupBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{'permissions-group.filter-form-name' | translate}} </mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>

          @if (!filterPermissionsGroupLoading) {
          <button title="Filtrar" (click)="filterPermissionsGroup('nextPage', null)" class="btn btn-success">
            {{'permissions-group.filter-form-button' | translate}}
          </button>
          }
          @if (filterPermissionsGroupLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!--Tabela-->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      @if (length > 0) {
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')">
      </app-table-header>
      }
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [rows]="pageSize" [totalRecords]="length" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">{{'permissions-group.table-name' | translate}}</th>
              <th pSortableColumn="userSet">{{'permissions-group.table-user' | translate}}</th>
              <th pSortableColumn="actions">{{'permissions-group.table-actions' | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.name}}</td>
              <td>{{row.userSet.count }}</td>
              <td>
                <p-button styleClass="btn-actions" (click)=" openSidebarUpdate(row, false)" icon="pi pi-pen-to-square"
                  [rounded]="true" />

                <p-button styleClass="btn-view" (click)="openSidebarUpdate(row, true)" icon="pi pi-eye"
                  [rounded]="true" />

              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
  <!-- Modal de edição de Grupos de Permissões -->
  @if (isUpdatePermissionsGroup) {
  <div class="sidebar-edit" [formGroup]="permissionsGroupUpdateForm">
    <mat-icon (click)="closeSidebarUpdate()">clear</mat-icon>
    @if (!viewController) {
    <h2> {{'permissions-group.edit-form' | translate}} </h2>
    }
    @if (viewController) {
    <h2> {{'permissions-group.view-form' | translate}} </h2>
    }
    <hr>
    <mat-form-field appearance="outline">
      <mat-label> {{'permissions-group.edit-form-name' | translate}} </mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label> {{'permissions-group.edit-form-user-permissions' | translate}} </mat-label>
      <mat-select multiple>
        <mat-option #availablePermissionsCheck (click)="selectAllAvailablePermissionsUpdate(availablePermissionsCheck)">
          {{'permissions-group.select-all-permissions' | translate}}
        </mat-option>
        @for (availablePermissions of availablePermissionsListUpdate; track availablePermissions) {
        <mat-checkbox color="primary" (change)="checkAvailablePermissionsUpdate(availablePermissions)"
          [checked]="availablePermissions.checked" [id]="availablePermissions.id">
          {{availablePermissions.name}}
        </mat-checkbox>
        }
      </mat-select>
    </mat-form-field>
    @if (!updatePermissionsGroupLoading) {
    <button class="btn btn-success" title="Salvar" (click)="updatePermissionsGroup()" [disabled]="viewController">
      {{'permissions-group.edit-form-save-button' | translate}}
    </button>
    }
    <button class="btn btn-danger" title="Deletar" (click)="deletePermissionGroup()" [disabled]="viewController">
      {{'permissions-group.edit-form-delete-button' | translate}}
    </button>
    @if (updatePermissionsGroupLoading) {
    <mat-spinner [diameter]="30"></mat-spinner>
    }
  </div>
  }
</div>